import React, { useState } from "react";
import { Sidebar, Menu, MenuItem, menuClasses } from "react-pro-sidebar";
import { Box, Collapse, List } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  Login,
  Dashboard,
  ManageAccounts,
  HowToReg,
  ExpandMore,
  GroupAdd,
  AppRegistration,
  ContactsOutlined,
  Beenhere,
  Newspaper,
  School,
  ClassOutlined,
  People,
  CastForEducation,
  CalendarToday,
  HowToVote,
} from "@mui/icons-material";
import FolderIcon from "@mui/icons-material/Folder";
// import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import { logout } from "../../redux/actions/userAction";
import logo from "../images/logo.jpg";

const SidebarAdm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  const { confirm } = Modal;
  const [admissionOpen, setAdmissionOpen] = useState(false);

  const [academicOpen, setAcademicOpen] = useState(false);
  const [bannersOpen, setBannersOpen] = useState(false);
  const [onlineExamsOpen, setOnlineExamsOpen] = useState(false);
  const [coursesBatchOpen, setCoursesBatchOpen] = useState(false);
  const [eventsGalleryOpen, setEventsGalleryOpen] = useState(false);
  const [feesOpen, setFeesOpen] = useState(false);

  const handleLogout = () => {
    confirm({
      title: "Are you sure you want to Log out?",
      icon: <ExclamationCircleOutlined />,
      content: "Your current session will be terminated.",
      onOk() {
        dispatch(logout());
        localStorage.clear();
        message.success("Logout Successfully");
        navigate("/login");
        window.location.reload();
      },
    });
  };

  return (
    <Sidebar backgroundColor="white" style={{ borderRightStyle: "none" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box>
          <Menu
            menuItemStyles={{
              button: {
                [`&.${menuClasses.button}`]: {
                  color: "#000",
                },
                [`&.${menuClasses.disabled}`]: {
                  color: "green",
                },
                "&:hover": {
                  backgroundColor: "#fafafa",
                  color: "#1976d2",
                },
              },

              icon: {
                [`&.${menuClasses.icon}`]: {
                  color: "#1976d2",
                },
              },
            }}
          >
            <MenuItem
              style={{ marginTop: "20px", color: "#000" }}
              display="flex"
              alignItems="center"
              component={<Link to="/dashboard" />}
            >
              <img
                // src={logo }
                src={logo}
                alt="Logo"
                style={{
                  height: "130px",
                  width: "150px",
                  borderRadius: "50%",
                  marginRight: "10px",
                  marginTop: "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            </MenuItem>
            <MenuItem style={{ marginTop: "60px", color: "#000" }}>
              <b>{user.name}</b>
            </MenuItem>
            <hr />
            <MenuItem
              component={<Link to="/dashboard" />}
              icon={<Dashboard />}
              style={{
                color: location.pathname === "/dashboard" ? "#1976d2" : "#000",
                backgroundColor:
                  location.pathname === "/dashboard" ? "#f1f1f1" : "inherit",
              }}
            >
              Dashboard
            </MenuItem>
            <MenuItem
              icon={<FolderIcon />}
              onClick={() => setBannersOpen(!bannersOpen)}
            >
              {" "}
              Banners{" "}
            </MenuItem>

            <Collapse in={bannersOpen}>
              <List disablePadding>
                <hr />
                <MenuItem
                  component={<Link to="/admin/institute/home" />}
                  icon={<HowToReg sx={{ color: "#1976d2" }} />}
                  style={{
                    color:
                      location.pathname === "/admin/institute/home"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/institute/home"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Home Banner
                </MenuItem>
                <MenuItem
                  component={<Link to="/admin/institute/home-highlights" />}
                  icon={<HowToReg sx={{ color: "#1976d2" }} />}
                  style={{
                    color:
                      location.pathname === "/admin/institute/home-highlights"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/institute/home-highlights"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Home Highlights
                </MenuItem>
                <MenuItem
                  component={<Link to="/admin/institute/about" />}
                  icon={<HowToReg sx={{ color: "#1976d2" }} />}
                  style={{
                    color:
                      location.pathname === "/admin/institute/about"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/institute/about"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  About Highlights
                </MenuItem>
                <hr />
              </List>
            </Collapse>

            <MenuItem
              icon={<FolderIcon />}
              onClick={() => setOnlineExamsOpen(!onlineExamsOpen)}
            >
              {" "}
              Online Exams{" "}
            </MenuItem>
            <Collapse in={onlineExamsOpen}>
              <List disablePadding>
                <hr />
                <MenuItem
                  component={<Link to="/admin/exams" />}
                  icon={<GroupAdd />}
                  style={{
                    color:
                      location.pathname === "/admin/exams" ? "#1976d2" : "#000",
                    backgroundColor:
                      location.pathname === "/admin/exams"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Exams
                </MenuItem>

                <MenuItem
                  component={<Link to="/admin/reports" />}
                  icon={<GroupAdd />}
                  style={{
                    color:
                      location.pathname === "/admin/reports"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/reports"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Reports
                </MenuItem>

                <MenuItem
                  component={<Link to="/admin/top/reports" />}
                  icon={<GroupAdd />}
                  style={{
                    color:
                      location.pathname === "/admin/top/reports"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/top/reports"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                 Top Reports
                </MenuItem>

                <MenuItem
                  component={<Link to="/admin/guest/students" />}
                  icon={<GroupAdd />}
                  style={{
                    color:
                      location.pathname === "/admin/guest/students"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/guest/students"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Guest Students
                </MenuItem>
                <hr />
              </List>
            </Collapse>

            <MenuItem
              icon={<FolderIcon />}
              onClick={() => setCoursesBatchOpen(!coursesBatchOpen)}
            >
              {" "}
              Courses & Batch{" "}
            </MenuItem>
            <Collapse in={coursesBatchOpen}>
              <List disablePadding>
                <hr />
                <MenuItem
                  component={<Link to="/admin/courses" />}
                  icon={<School />}
                  style={{
                    color:
                      location.pathname === "/admin/courses"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/courses"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Courses
                </MenuItem>

                <MenuItem
                  component={<Link to="/admin/batch" />}
                  icon={<ClassOutlined />}
                  style={{
                    color:
                      location.pathname === "/admin/batch" ? "#1976d2" : "#000",
                    backgroundColor:
                      location.pathname === "/admin/batch"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Batch & Class
                </MenuItem>

                <MenuItem
                  component={<Link to="/admin/student/list" />}
                  icon={<People />}
                  style={{
                    color:
                      location.pathname === "/admin/student/list"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/student/list"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Student List
                </MenuItem>
                <hr />
              </List>
            </Collapse>

            <MenuItem
              component={<Link to="/admin/teachers" />}
              icon={<GroupAdd />}
              style={{
                color:
                  location.pathname === "/admin/teachers" ? "#1976d2" : "#000",
                backgroundColor:
                  location.pathname === "/admin/teachers"
                    ? "#f0f0f0"
                    : "inherit",
              }}
            >
              Teachers
            </MenuItem>

            <MenuItem
              icon={<FolderIcon />}
              onClick={() => setEventsGalleryOpen(!eventsGalleryOpen)}
            >
              {" "}
              Events & Gallery{" "}
            </MenuItem>

            <Collapse in={eventsGalleryOpen}>
              <List disablePadding>
                <hr />
                <MenuItem
                  component={<Link to="/admin/events-news" />}
                  icon={<Newspaper />}
                  style={{
                    color:
                      location.pathname === "/admin/events-news"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/events-news"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Events & News
                </MenuItem>

                <MenuItem
                  component={<Link to="/admin/gallery" />}
                  icon={<Newspaper />}
                  style={{
                    color:
                      location.pathname === "/admin/gallery"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/gallery"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Gallery
                </MenuItem>
                <hr />
              </List>
            </Collapse>

            <MenuItem
              icon={<FolderIcon />}
              onClick={() => setAcademicOpen(!academicOpen)}
            >
              {" "}
              Academic{" "}
            </MenuItem>

            <Collapse in={academicOpen}>
              <List disablePadding>
                <hr />
                <MenuItem
                  component={<Link to="/admin/academic-calendar" />}
                  icon={<CalendarToday sx={{ color: "#1976d2" }} />}
                  style={{
                    color:
                      location.pathname === "/admin/academic-calendar"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/academic-calendar"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Academic Calendar
                </MenuItem>

                <MenuItem
                  component={<Link to="/admin/academic-exam-time-table" />}
                  icon={<HowToVote sx={{ color: "#1976d2" }} />}
                  style={{
                    color:
                      location.pathname === "/admin/academic-exam-time-table"
                        ? "#1976d2"
                        : "#000",

                    backgroundColor:
                      location.pathname === "/admin/academic-exam-time-table"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Academic Exam Time Table
                </MenuItem>

                <hr />
              </List>
            </Collapse>

            {/* Academic Dropdown */}
            {/* <MenuItem
              icon={<CastForEducation />}
              onClick={() => setAcademicOpen(!academicOpen)}
            >
              Academic
              <ExpandMore
                sx={{ mb: -1, alignItems: "center", justifyContent: "center" }}
              />
            </MenuItem>

            <Collapse in={academicOpen} timeout="auto" unmountOnExit>
              <List disablePadding>
                <hr />
                <Menu sx={{ pl: 4 }}>
                  <MenuItem
                    component={<Link to="/admin/academic-calendar" />}
                    icon={<CalendarToday sx={{ color: "#1976d2" }} />}
                    style={{
                      color:
                        location.pathname === "/admin/academic-calendar"
                          ? "#1976d2"
                          : "#000",
                      backgroundColor:
                        location.pathname === "/admin/academic-calendar"
                          ? "#f0f0f0"
                          : "inherit",
                    }}
                  >
                    Academic Calendar
                  </MenuItem>
                  <MenuItem
                    component={<Link to="/admin/academic-exam-time-table" />}
                    icon={<HowToVote sx={{ color: "#1976d2" }} />}
                    style={{
                      color:
                        location.pathname === "/admin/academic-exam-time-table"
                          ? "#1976d2"
                          : "#000",

                      backgroundColor:
                        location.pathname === "/admin/academic-exam-time-table"
                          ? "#f0f0f0"
                          : "inherit",
                    }}
                  >
                    Academic Exam Time Table
                  </MenuItem>
                </Menu>
              </List>
              <hr />
            </Collapse> */}

            <MenuItem
              component={<Link to="/admin/admission" />}
              icon={<ContactsOutlined />}
              style={{
                color:
                  location.pathname === "/admin/admission" ? "#1976d2" : "#000",
                backgroundColor:
                  location.pathname === "/admin/admission"
                    ? "#f0f0f0"
                    : "inherit",
              }}
            >
              Admissions
            </MenuItem>

            <MenuItem
              icon={<FolderIcon />}
              onClick={() => setFeesOpen(!feesOpen)}
            >
              {" "}
              Online Fees{" "}
            </MenuItem>

            <Collapse in={feesOpen}>
              <List disablePadding>
                <hr />
                {/* Online Fees */}
                <MenuItem
                  component={<Link to="/admin/online-fees" />}
                  icon={<ContactsOutlined />}
                  style={{
                    color:
                      location.pathname === "/admin/online-fees"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/online-fees"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  Online Fees
                </MenuItem>

                <MenuItem
                  component={<Link to="/admin/school-fees-management" />}
                  icon={<ContactsOutlined />}
                  style={{
                    color:
                      location.pathname === "/admin/school-fees-management"
                        ? "#1976d2"
                        : "#000",
                    backgroundColor:
                      location.pathname === "/admin/school-fees-management"
                        ? "#f0f0f0"
                        : "inherit",
                  }}
                >
                  School Fees Management
                </MenuItem>

                <hr />
              </List>
            </Collapse>

            <MenuItem
              component={<Link to="/admin/contact" />}
              icon={<ContactsOutlined />}
              style={{
                color:
                  location.pathname === "/admin/contact" ? "#1976d2" : "#000",
                backgroundColor:
                  location.pathname === "/admin/contact"
                    ? "#f0f0f0"
                    : "inherit",
              }}
            >
              Contact
            </MenuItem>
            <MenuItem
              component={<Link to="/admin/profile" />}
              icon={<ManageAccounts />}
              style={{
                color:
                  location.pathname === "/admin/profile" ? "#1976d2" : "#000",
                backgroundColor:
                  location.pathname === "/admin/profile"
                    ? "#f0f0f0"
                    : "inherit",
              }}
            >
              Manage Accounts
            </MenuItem>
          </Menu>
        </Box>

        {/* Log Out */}
        <Box sx={{ pb: 2 }}>
          <Menu>
            <hr />
            <MenuItem
              onClick={handleLogout}
              icon={<Login />}
              // style={{ color: "#000" }}
              style={{
                color: location.pathname === "/login" ? "#1976d2" : "#1976d2",
                backgroundColor:
                  location.pathname === "/login" ? "#f2f2f2" : "inherit",
              }}
            >
              Log out
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Sidebar>
  );
};

export default SidebarAdm;
